import { AuthOverlay } from "@/app/overlays";
import { WelcomeOverlay } from "@/components/onboarding/WelcomeOverlay";
import { observer } from "mobx-react-lite";

interface AppOverlaysProps {}

export const StandardModeAppAppOverlays = observer<AppOverlaysProps>(() => {
  return (
    <>
      <AuthOverlay />
      <WelcomeOverlay />
    </>
  );
});
